import api from './api';

const resource = 'Terminal/';

export const list = async (query = '') => {
  return await api.get(resource + 'List' + query);
};

export const getById = async (id) => {
  return await api.get(resource + 'Get?id=' + id);
};

export const upsert = async (body) => {
  return await api.post(resource + 'Upsert', body);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

export const getTerminalSession = async (query) => {
  return await api.get(resource + 'GetTerminalSession' + query);
};

export const getClickCount = async (query) => {
  return await api.get(resource + 'GetClickCount' + query);
};

const terminalApi = { list, getById, upsert, deleteById, getClickCount };

export default terminalApi;
